import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import StyledComponent from '~/components/Styled/Styled';

import css from './StatBar.scss';

class StatBar extends React.Component {
  renderMatchupStatsLabel() {
    const { team1Stat, team1Rank, team2Stat, team2Rank, statName } = this.props;
    return (
      <Fragment>
        <div className={css.team1StatInfo}>
          {team1Stat}
          {team1Rank && <div className={css.rank}>({team1Rank})</div>}
        </div>
        <div className={css.statInfo}>{statName}</div>
        <div className={css.team2StatInfo}>
          {team2Rank && <div className={css.rank}>({team2Rank})</div>}
          {team2Stat}
        </div>
      </Fragment>
    );
  }

  renderSeasonStatsLabel() {
    const { team1Stat, team1Rank, statName } = this.props;
    return (
      <Fragment>
        <div className={css.teamSeasonStatInfo}>{statName}</div>
        <div className={css.seasonStatInfo}>
          {team1Rank && <div className={css.rank}>({team1Rank})</div>}
          {team1Stat}
        </div>
      </Fragment>
    );
  }

  render() {
    const { team1Percent, team2Percent, isNegativeStat, type } = this.props;
    const fullNum = team1Percent + team2Percent;
    const statsAreZeroZero = team1Percent === 0 && team2Percent === 0;
    const team1Percentage = statsAreZeroZero ? 50 : team1Percent / fullNum * 100;
    const team2Percentage = statsAreZeroZero ? 50 : team2Percent / fullNum * 100;

    const showTeam1 = team1Percentage || !team2Percentage;
    const showTeam2 = !team1Percentage || team2Percentage;

    const team2class = type === 'matchup' ? css.team2StatBar : css.seasonStatBar;

    return (
      <div className={css.container}>
        <div className={css.statLabelsContainer}>
          {type === 'matchup' ? this.renderMatchupStatsLabel() : this.renderSeasonStatsLabel()}
        </div>

        {!this.props.isBarHidden && (
          <Fragment>
            {!!showTeam1 && (
              <div
                className={css.team1StatBar}
                style={{
                  width: `calc(${isNegativeStat ? team2Percentage : team1Percentage}% - 10px)`,
                }}
              />
            )}
            {!!showTeam2 && (
              <div
                className={team2class}
                style={{
                  width: `calc(${isNegativeStat ? team1Percentage : team2Percentage}% - 10px)`,
                }}
              />
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

StatBar.propTypes = {
  statName: PropTypes.string.isRequired,
  team1Stat: PropTypes.number.isRequired,
  team2Stat: PropTypes.number.isRequired,
  team1Percent: PropTypes.number.isRequired,
  team2Percent: PropTypes.number.isRequired,
  team1Rank: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  team2Rank: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isNegativeStat: PropTypes.bool,
  isPercentage: PropTypes.bool,
  type: PropTypes.oneOf(['matchup', 'season']),
  team1Numerator: PropTypes.number.isRequired,
  team1Denominator: PropTypes.number.isRequired,
  team2Numerator: PropTypes.number.isRequired,
  team2Denominator: PropTypes.number.isRequired,
  isBarHidden: PropTypes.bool,
};

StatBar.defaultProps = {
  isPercentage: false,
  isNegativeStat: false,
  team1Rank: null,
  team2Rank: null,
  type: 'matchup',
  isBarHidden: false,
};

StatBar.displayName = 'StatBar';

export default StyledComponent(StatBar, [css]);
